// extracted by mini-css-extract-plugin
module.exports = {"container":"PayrollStat_container__3ICws","isLink":"PayrollStat_isLink__1FEZh","term":"PayrollStat_term__3xrBC","value":"PayrollStat_value__1-chI"};